import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useEngagementPostInfluencersQuery, QueryengagementPostInfluencersArgs } from '@anytag/graphql';

interface Props {
  engagementId: number;
  options?: QueryHookOptions<Query, QueryengagementPostInfluencersArgs>;
}

export const useEngagementPostInfluencersOptions = ({ engagementId, options }: Props) => {
  const { data, loading } = useEngagementPostInfluencersQuery({
    fetchPolicy: 'cache-and-network',
    variables: { pk: engagementId },
    ...options
  });

  const influencers = data?.engagementPostInfluencers || [];

  return {
    loading,
    influencers,
    influencerOptions: getSelectOptions(influencers)
  };
};
